import { createRouter, createWebHistory } from 'vue-router';
import authMiddleware from '~/middleware/auth-organization-context';
import { authGuard } from '@auth0/auth0-vue';
import Conversation from '~/pages/conversation';
import Callback from '~/pages/callback';
import Dashboard from '~/pages/dashboard';
import { Routes } from '~/constants/routes';
import Login from '~/pages/login';
import Home from '~/pages/home';
import Error from '~/pages/error';
import AuthoringConversation from '~/pages/authoring-conversation';
import MyCreations from '~/pages/my-creations.vue';
import usePostHog from './composables/usePostHog';

const routes = [
  //  TODO transform the routes in named routes
  // TODO Routes from constants need adjusted to contain the name of the routes
  {
    path: Routes.Home,
    component: Home,
  },
  {
    path: Routes.Authoring.path,
    name: Routes.Authoring.name,
    component: AuthoringConversation,
    beforeEnter: [authGuard, authMiddleware],
  },
  {
    path: Routes.Conversation.path,
    name: Routes.Conversation.name,
    component: Conversation,
    beforeEnter: [authGuard, authMiddleware],
  },
  { path: Routes.Callback, component: Callback },
  { path: Routes.Dashboard, component: Dashboard, beforeEnter: [authGuard, authMiddleware] },
  { path: Routes.Login, component: Login },
  {
    path: '/:pathMatch(.*)*/:statusCode',
    name: 'Error',
    component: Error,
    props: true,
  },
  {
    path: Routes.MyCreations,
    component: MyCreations,
    name: Routes.MyCreations,
    beforeEnter: [authGuard, authMiddleware],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// const { posthog } = usePostHog();

export default router;
